import React, { Component } from "react";


import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import RemoteTable from "../../../components/Common/RemoteTable";
import CampaignSourceModal from "./components/CampaignSourceModal";
import SweetAlert from "react-bootstrap-sweetalert";
import styled from "styled-components";
import {
  addCampaignSource,
  deleteCampaignSource,
  getCampaignSourcesList,
  updateCampaignSourceProfile,
  setCampaignSourcesList
} from "../../../store/campaigns/sources/actions";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class Sources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddCampaignSource: false,
      editData: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getCampaignSourcesList({
      ...this.props.data,
      search: '',
      ordering: '',
      results: [],
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleTableChange = data => {
    this.props.getCampaignSourcesList(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddSourceModal = () => {
    this.setState(prevState => ({
      viewAddCampaignSource: !prevState.viewAddCampaignSource,
      editData: null,
    }));
  };

  render() {
    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.name}"!`,
          onConfirm: () => {
            this.props.deleteCampaignSource(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      const onClickEdit = e => {
        onClickRow(e, row, "edit");
      };

      return (
        <React.Fragment>
          {this.props.permissions["change_campaignsourcemodel"] && (
            <Button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={onClickEdit}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </Button>
          )}
          {this.props.permissions["delete_campaignsourcemodel"] && (
            <Button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </Button>
          )}
        </React.Fragment>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <NameLink onClick={e => onClickRow(e, row, "edit")}>
          {row[label]}
        </NameLink>
      );
    };

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "name"),
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
        formatter: (cell, row) => nameFormatter(cell, row, "description"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    const onClickRow = (e, row, type) => {
      if (this.props.permissions?.["view_campaignsourcemodel"]) {
        this.setState(prevState => ({
          viewAddCampaignSource: !prevState.viewAddCampaignSource,
          editData: type === "edit" ? row : null,
        }));
      }
    };

    return (
      <React.Fragment>
        {this.state.viewAddCampaignSource && (
          <CampaignSourceModal
            toggle={this.toggleViewAddSourceModal}
            isOpen={this.state.viewAddCampaignSource}
            data={this.props.data}
            editData={this.state.editData}
            addCampaignSource={this.props.addCampaignSource}
            updateCampaignSourceProfile={this.props.updateCampaignSourceProfile}
            permissions={this.props.permissions}
          />
        )}

        <div className="page-content">
        <ModifiedMetaTags title="Campaign source | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Campaign sources"
              link="/dashboard"
            />
            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>
                  You are about to delete this source? <br /> If you are not
                  sure, you can close this form.
                </p>
              </SweetAlert>
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions &&
                        this.props.permissions["add_campaignsourcemodel"] ===
                          "add_campaignsourcemodel" && (
                          <Button
                            type="button"
                            color="success"
                            className="btn-rounded mb-2 me-2"
                            onClick={this.toggleViewAddSourceModal}
                          >
                            <i className="mdi mdi-plus me-1" /> Add campaign
                            source
                          </Button>
                        )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const NameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

Sources.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  getCampaignSourcesList: PropTypes.func,
  addCampaignSource: PropTypes.func,
  deleteCampaignSource: PropTypes.func,
  updateCampaignSourceProfile: PropTypes.func,
  history: PropTypes.any,
  permissions: PropTypes.any,
  setCampaignSourcesList: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.CampaignSourceList.data,
  loading: state.CampaignSourceList.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCampaignSourcesList,
  setCampaignSourcesList,
  addCampaignSource,
  deleteCampaignSource,
  updateCampaignSourceProfile,
})(Sources);
